import React, { useState } from "react";
import { Notification, Collapsible } from 'grommet';

const BannerNotification = () => {

  const [showNotification, setShowNotification] = useState(true);

  return (
    <Collapsible open={showNotification}>
      <Notification
        status="normal"
        title="Welcome!"
//        status="warning"
//        title="Warning"      
        margin={{ top: '5px' }}
        onClose={() => setShowNotification(false)}
        actions={[
          {
            href: 'https://www.hpe.com/',
            label: 'More info',
          },
        ]}
        message="We hope you enjoy your new ops site. "
 //       message="Subscription activation rates below statistical norm. "
        global
      />
    </Collapsible>
   );
};

export { BannerNotification as Notification };